import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { useSelector } from 'hooks/useSelector';
import { pluralise } from 'lib/pluralise';
import { stringRemoveNewLines } from 'lib/riskbase';
import { theme } from 'lib/theme';
import { union } from 'lodash';
import React from 'react';
import { View } from 'react-native';
import { Chip } from 'screens/AssessmentScreen/Finding/Chip';
import {
  selectRemoteCategories,
  selectRemoteAseSetupControl,
} from 'store/remote/selectors';

type Props = {
  id: number;
  onPress: (id: number) => void;
  checked: boolean;
};

export const ControlListItem: React.FC<Props> = React.memo(
  ({ id, onPress, checked }) => {
    const control = useSelector((state) =>
      selectRemoteAseSetupControl(state, id),
    );
    const categories = useSelector(selectRemoteCategories)!;

    if (!control) {
      return null;
    }

    const countChecklistItems = union(
      control.positiveChecklistItemIds,
      control.negativeChecklistItemIds,
    ).length;
    const countQuestions = control.questionIds.length;

    const category = categories[control.categoryId] ?? categories[0]!;

    return (
      <Card
        separator={null}
        style={{ marginBottom: theme.paddingVertical / 2 }}
      >
        <CardRow onPress={() => onPress(id)} checkedValue={checked}>
          <Txt size="small">
            {stringRemoveNewLines(control.what)}
            {!!control.why && (
              <Txt size="small" style={{ color: theme.colors.fieldValueText }}>
                {' '}
                {stringRemoveNewLines(control.why)}
              </Txt>
            )}
          </Txt>
          {(category.id !== 0 || !!countQuestions || !!countChecklistItems) && (
            <View
              style={{
                alignItems: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {category.id !== 0 && (
                <Chip iconSource={ICONS.TagLight}>{category.name}</Chip>
              )}
              {(!!countQuestions || !!countChecklistItems) && (
                <Txt
                  size="xxxsmall"
                  style={{ color: theme.colors.fieldValueText, marginTop: 6 }}
                >
                  {pluralise(countQuestions, '1 Question', '{x} Questions', '')}
                  {!!countQuestions && !!countChecklistItems && ' • '}
                  {pluralise(
                    countChecklistItems,
                    '1 Checklist Item',
                    '{x} Checklist Items',
                    '',
                  )}
                </Txt>
              )}
            </View>
          )}
        </CardRow>
      </Card>
    );
  },
);
